export const TARGET_TAGS = 26;
export const TARGET_KRITIK = 4;
export interface HealthCheck {
  version: string;
  status: string;
  database: {
    status: string;
    message: string;
  };
  uptime: string;
  responseTime: string;
}

export interface ApiResponse<T> {
  data: T;
  message?: string;
}

// Pembeda target or not
export const prodiTarget = new Set(['H10', 'H11']),
  aktTarget = new Set(['23', '24', '25']);
